<template>
  <div>
    <div class="form-row">
      <div
        class="
          col-12
          d-flex
          align-items-center
          flex-wrap
          mb-3
          flex-column flex-sm-row
          text-center
        "
      >
        <h5 class="">MINHAS INSCRIÇÕES</h5>
      </div>

      <div class="col-12 d-flex align-items-start pb-3" style="overflow: auto">
        <LoaderContent
          v-if="isLoading"
          :welcomeMessage="false"
          :alignSpinnerTop="true"
        />

        <div
          class="rounded-xl shadow-md flex-shrink-0 my-2 mr-5 p-4"
          v-for="(subscription, index) in subscriptions"
          :key="index"
          v-if="
            subscription.company &&
            subscription.company.id == $store.state.companyId
          "
        >
          <router-link
            :to="'/vagas/' + subscription.slug"
            class="d-flex flex-column"
            style="min-height: 115px"
          >
            <span
              class="h5 font-weight-normal text-dark"
              v-if="subscription.opportunity"
            >
              {{ $helpers.toTitle(subscription.opportunity.title) }}
            </span>

            <div class="d-flex mt-3 mb-2 text-secondary">
              <calendar-icon class="h4 mb-0 mr-2" />
              <span>{{
                $moment(subscription.createdAt, "YYYY-MMM-DD HH:mm A").format(
                  "LLL"
                )
              }}</span>
            </div>

            <div class="d-flex text-secondary">
              <map-marker-icon class="h4 mb-0 mr-2" />

              <div
                v-if="
                  subscription.opportunity && subscription.opportunity.address
                "
              >
                <span
                  v-if="
                    subscription.opportunity.address.city &&
                    subscription.opportunity.address.stateAbbr
                  "
                  >{{ subscription.opportunity.address.city }} -
                  {{ subscription.opportunity.address.stateAbbr }}</span
                ><br />
                <span v-if="subscription.opportunity.address.street">{{
                  subscription.opportunity.address.street
                }}</span>
                <span v-if="subscription.opportunity.address.number"
                  >, {{ subscription.opportunity.address.number }}</span
                >
                <span v-if="subscription.opportunity.address.neighborhood">
                  - {{ subscription.opportunity.address.neighborhood }}</span
                >
              </div>
              <span v-else>Endereço não foi cadastrado</span>
            </div>
          </router-link>

          <hr />

          <SubscriptionTests :subscription="subscription" />
        </div>

        <button
          class="btn btn-blue-ml align-self-center flex-shrink-0"
          @click="loadSubscriptions"
          v-if="hasNext && !isLoading"
        >
          Carregar mais...
        </button>
        <SpinnerLoader
          v-if="isLoading"
          class="align-self-center flex-shrink-0"
        />
      </div>
    </div>

    <p v-if="subscriptions.length == 0">Nenhuma inscrição</p>
  </div>
</template>

<script>
import LoaderContent from "@/components/loader/LoaderContent.vue";
import SpinnerLoader from "@/components/loader/SpinnerLoader";
import SubscriptionTests from "./SubscriptionTests.vue";
import MapMarkerIcon from "vue-material-design-icons/MapMarkerOutline.vue";
import CalendarIcon from "vue-material-design-icons/Calendar.vue";

export default {
  name: "BoxSubscriptions",

  data() {
    return {
      isLoading: false,
      page: 0,
      hasNext: true,
    };
  },

  computed: {
    subscriptions() {
      let sub;
      // sub = this.$store.state.opportunities.subscriptions.sort(function (a, b) {
      //   if (a.createdAt < b.createdAt) {
      //     return 1;
      //   }
      //   if (a.createdAt > b.createdAt) {
      //     return -1;
      //   }
      //   return 0;
      // }) || [];

      sub =
        this.$store.state.opportunities.subscriptions.sort().reverse() || [];
      return sub;
    },
  },

  components: {
    LoaderContent,
    SpinnerLoader,
    SubscriptionTests,
    MapMarkerIcon,
    CalendarIcon,
  },

  mounted() {
    this.loadSubscriptions();
  },

  methods: {
    loadSubscriptions() {
      this.isLoading = true;
      this.page++;

      this.$store
        .dispatch("opportunities/subscriptionsWithPagination", {
          page: this.page,
          getOnlineTests: true,
        })
        .then((subscriptions) => {
          this.hasNext = subscriptions.meta.next_page != null;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>